import TemplateView from "../../../TemplateView"
import $ from "jquery"
import {bindActionCreators} from 'redux'
import ColumnConfiguratorMenu from './ColumnConfiguratorMenu'
import {connect} from '../../../redux/utils'
import {afterClose, beforeOpen} from './actions'

class ConfigurationButton extends TemplateView {
    constructor({
        beforeOpen = () => {},
        afterClose = () => {},

    }) {
        super()

        this.actions = {
            beforeOpen,
            afterClose,
        }

        this.configurationMenu = new ColumnConfiguratorMenu({
            onHide: () => {
                this.$el.removeClass('pressed')
                this.actions.afterClose()
            },
            onShow: () => {
                if (!this.configurationMenu.ignoreNextShowing) {
                    this.$el.addClass("pressed");
                }
                this.actions.beforeOpen()
            }
        }).init($("body"))
    }

    templateHtml() {
        return "<div class='configuratorButton_taskManagement'>" +
               "    <div class='icon'/>" +
               "    <div class='label'><%-label%></div>" +
               "</div>"
    }

    messageKeys() {
        return {
            label: "task.list.configure_columns",
        }
    }

    afterRender() {
        this.configurationMenu.setState({
            $showAt: this.$el,
            params: {offset: "0px 1px"},
        })

        this.bindClick(() => {
            this.configurationMenu.openMenu()
        })
    }
}
export default connect(
    state => ({}),
    dispatch => ({
        beforeOpen: bindActionCreators(beforeOpen, dispatch),
        afterClose: bindActionCreators(afterClose, dispatch),
    })
)(ConfigurationButton)



// WEBPACK FOOTER //
// ./web/js/taskManagement/tasksTable/configurationMenu/ConfigurationButton.js